export const generateNewColumns = (oldColumns, apiColumns) => {

    // map of old columns by accessor
    const oldColumnMap = new Map(
        oldColumns.map((column) => [column.accessor, column])
    );

    const newColumns=apiColumns.map((apiColumn) => {
        const oldColumn = oldColumnMap.get(apiColumn.accessor);

        // If no matching old column, return the API column as is
        if (!oldColumn) {
            return apiColumn;
        }

        // Remove the properties that should NOT be copied
        const {
            accessor,
            ...remainingOldColProps
        } = oldColumn;

        // API column values take precedence for title/accessor/initiallyHidden
        return {
            ...remainingOldColProps,
            ...apiColumn,
        };
    });

    //filter out action from new columns if it generated from old columns to remove duplication
    const filteredColumns = newColumns.filter((c) => c.title !== "Action" && c.accessor);

    //take the action column from old columns and add it to the end of new columns with a accessor if it exists
    const actionColumn = oldColumns.find((c) => c.title === "Action" && !c.accessor);

    if (actionColumn) 
    {
        filteredColumns.push({
            ...actionColumn,
            accessor: "__action__",
        });
    }

    return filteredColumns; //new columns
}